export const PIZZERIA_MENU_STRUCTURE = [
  {
    section_key: "PIZZE",
    title: "PIZZE",
    description: "Disponibili tonde e in pala da 60 cm",
    item_column_label: "Pizza",
    description_column_label: "Ingredienti",
    default_price_labels: ["Tonda", "In pala"],
    subsections: [
      { key: "PIZZE_CLASSICHE", title: "PIZZE CLASSICHE" },
      { key: "PIZZE_BIANCHE", title: "PIZZE BIANCHE" }
    ]
  },
  {
    section_key: "PUCCE",
    title: "PUCCE",
    item_column_label: "Puccia",
    description_column_label: "Ingredienti",
    default_price_labels: ["Prezzo"],
    subsections: []
  },
  {
    section_key: "PANINI",
    title: "PANINI",
    item_column_label: "Panino",
    description_column_label: "Ingredienti",
    default_price_labels: ["Prezzo"],
    subsections: []
  },
  {
    section_key: "FRITTINI",
    title: "FRITTINI",
    item_column_label: "Prodotto",
    description_column_label: "Descrizione",
    default_price_labels: ["Prezzo"],
    subsections: []
  }
];

const SECTION_ORDER = Object.fromEntries(
  PIZZERIA_MENU_STRUCTURE.map((section, index) => [section.section_key, index + 1])
);

const SUBSECTION_ORDER = {
  PIZZE_CLASSICHE: 1,
  PIZZE_BIANCHE: 2
};

export function getPizzeriaSectionConfig(sectionKey) {
  return PIZZERIA_MENU_STRUCTURE.find((section) => section.section_key === sectionKey) || null;
}

export function getPizzeriaDefaultSubsection(sectionKey) {
  const section = getPizzeriaSectionConfig(sectionKey);
  if (!section || !Array.isArray(section.subsections) || section.subsections.length === 0) {
    return "";
  }
  return section.subsections[0].key;
}

export function getPizzeriaDefaultPriceLabels(sectionKey) {
  const section = getPizzeriaSectionConfig(sectionKey);
  if (!section || !Array.isArray(section.default_price_labels)) {
    return ["Prezzo"];
  }
  return section.default_price_labels;
}

export function sortPizzeriaMenuItems(items) {
  return [...items].sort((a, b) => {
    const sectionDiff = (SECTION_ORDER[a.section_key] || 99) - (SECTION_ORDER[b.section_key] || 99);
    if (sectionDiff !== 0) {
      return sectionDiff;
    }

    const subsectionDiff =
      (SUBSECTION_ORDER[a.subsection_key] || 99) - (SUBSECTION_ORDER[b.subsection_key] || 99);
    if (subsectionDiff !== 0) {
      return subsectionDiff;
    }

    const sortOrderDiff = (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0);
    if (sortOrderDiff !== 0) {
      return sortOrderDiff;
    }

    return String(a.name || "").localeCompare(String(b.name || ""), "it-IT");
  });
}
